function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.06 5.273L4 2.22.94 5.273 0 4.333l4-4 4 4-.94.94z",
    fill: props.fill
  }));
}
export default SvgArrowUp;